exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section-heading[data-v-01577c5e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.h3[data-v-01577c5e]{margin-left:20px}.blue[data-v-01577c5e]{color:#10284a}.white[data-v-01577c5e]{color:#fff}", ""]);

// exports
